import { createActions } from "direct-vuex";
import Axios, { AxiosResponse } from "axios";
import config from "@/config";
import { userActionContext } from ".";
import {
  UserIndexResponse,
  UserShowResponse,
  UserCreatePayload
} from "./types";

const path = config.hostname + "/users/";

export default createActions({
  async get(context) {
    const { commit, rootCommit, rootState } = userActionContext(context);
    try {
      rootCommit.START_LOADING();
      let result: AxiosResponse<UserIndexResponse> = await Axios.get(path, {
        params: { pagination: rootState.pagination }
      });
      commit.SET_USERS(result.data.users.data);
      rootCommit.SET_TOTAL_ITEMS(result.data.pagination.totalItems);
      rootCommit.END_LOADING();
      return { data: result.data };
    } catch (error) {
      console.log(error);
      rootCommit.END_LOADING();
      return { error };
    }
  },
  async find(context, id: string) {
    const { commit, rootCommit } = userActionContext(context);
    try {
      rootCommit.START_LOADING();
      let result: AxiosResponse<UserShowResponse> = await Axios.get(path + id);
      commit.SET_SELECTED(result.data.data);
      rootCommit.END_LOADING();
      return { data: result.data.data };
    } catch (error) {
      console.log(error);
      rootCommit.END_LOADING();
      return { error };
    }
  },
  async create(context, payload: UserCreatePayload) {
    const { state, rootCommit } = userActionContext(context);
    try {
      rootCommit.START_LOADING();
      let result: AxiosResponse<UserShowResponse> = await Axios.post<
        UserShowResponse
      >(path, { user: payload });
      rootCommit.END_LOADING();
      return { data: result.data.data };
    } catch (error) {
      console.log(error);
      rootCommit.END_LOADING();
      return { error };
    }
  },
  async update(context, attrs: { id: string; payload: UserCreatePayload }) {
    const { state, rootCommit } = userActionContext(context);
    try {
      rootCommit.START_LOADING();
      let result: AxiosResponse<UserShowResponse> = await Axios.put<
        UserShowResponse
      >(path + attrs.id, { user: attrs.payload });
      rootCommit.END_LOADING();
      return { data: result.data.data };
    } catch (error) {
      console.log(error);
      rootCommit.END_LOADING();
      return { error };
    }
  },
  async delete(context, id: string) {
    const { commit, rootCommit } = userActionContext(context);
    try {
      rootCommit.START_LOADING();
      let result: AxiosResponse<null> = await Axios.delete(path + id);
      commit.REMOVE_USER(id);
      rootCommit.END_LOADING();
      return { data: true };
    } catch (error) {
      console.log(error);
      rootCommit.END_LOADING();
      return { error };
    }
  }
});
